import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge conditional class names while letting later Tailwind utilities win
 * over earlier conflicting ones (e.g. `cn('p-2', condition && 'p-4')`).
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
